import React from 'react';
import { TNotificationDetail } from 'types/common';
import { getNotificationDetail } from 'api/provider';

let globalData: TNotificationDetail;

const useNotificationDetail = (): [TNotificationDetail | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TNotificationDetail>(globalData);
    const fetchData = async () => {
        if (loading) return;
        try {
            setLoading(true);
            //const init = await initNotificationDetail();
            const result = await getNotificationDetail();
            if (!result.error) {
                const resData = result?.data?.data;
                globalData = resData;
                setItems(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    return [items, loading, fetchData];
};

export default useNotificationDetail;
